module.exports = __webpack_public_path__ + "img/securitec-full-logo.efda09e2.png";